import { createSlice } from '@reduxjs/toolkit';
import { TSiteType } from '../../types/analytics';

const initialState = {
  siteType: 'desktop' as TSiteType,
};

/* istanbul ignore next */
const analyticsSlice = createSlice({
  initialState,
  name: 'analytics',
  reducers: {},
});

export const { reducer: analyticsReducer } = analyticsSlice;
